module.exports = __webpack_public_path__ + "static/media/iconpurple.00d7b9d2.png";